import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';

import { getFilteredEvents } from '../services/HandleFiltering';

import { selectEvent } from '../reducers/events';
import { switchView } from '../reducers/view';

import EventFilter from './eventFilter/EventFilter.jsx';
import ViewSwitcher from './ViewSwitcher.jsx';

const mapStateToProps = state => ({
  events: getFilteredEvents(state),
  view: state.view.view
});

const mapDispatchToProps = dispatch => ({
  changeView: viewName => changePageView(dispatch, viewName),
  changeFilter: filter => dispatch(filter)
});

function changePageView(dispatch, viewName) {
  dispatch(switchView(viewName));

  // Selected event makes no sense when switching map -> calendar
  if (viewName === 'CALENDAR') {
    dispatch(selectEvent(undefined));
  }
}

const FilterView = ({ events, view, changeFilter, changeView }) => {
  if (view !== 'EDITOR') {
    return (
      <div className="ibox-title">
        <Row>
          <Col md={9}>
            <EventFilter events={events} changeFilter={changeFilter} />
          </Col>
          <Col md={3} className="pull-right">
            <ViewSwitcher activeView={view} changeView={changeView} />
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className="ibox-title">
      <Row>
        <Col md={4} className="pull-left">
          <strong>Lisää uusi harjoitus </strong>
        </Col>
      </Row>
    </div>
  );
};

FilterView.propTypes = {
  events: PropTypes.array.isRequired,
  view: PropTypes.string.isRequired,
  changeFilter: PropTypes.func.isRequired,
  changeView: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterView);



// WEBPACK FOOTER //
// ./src/components/FilterView.jsx